import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const EmailNotVerified = ({ email, classes }) => (
    <div>
        <Typography variant={'h6'} className={`u-mb-medium `}>
            Email Verification Failure
        </Typography>
        <p>We have not been able to verify your email address on our system.</p>
        <p>You can resend the verification email if required.</p>
        <div className="row u-mb-small">
            <div className={'u-pt-medium col-xs-12 col-sm-6'}>
                <Link
                    className={classes.buttonPrimary}
                    to={`/verify/emailSent?email=${email}`}
                >
                    Resend Email
                </Link>
            </div>
            <div className={'u-pt-medium col-xs-12 col-sm-6 u-m-auto'}>
                <Link className={classes.buttonSecondary} to={'/login'}>
                    Cancel
                </Link>
            </div>
        </div>
    </div>
);

EmailNotVerified.propTypes = {
    email: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export default EmailNotVerified;
